export function isLiveFeatureEnabled () {
  const raw = String(process.env.VUE_APP_LIVE || 'ON').trim().toUpperCase()
  return raw !== 'OFF'
}
